// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/cloud_credentials.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import { CloudAccountCredentialsService } from "./cloud_credentials_pb";

/**
 * @generated from rpc chalk.server.v1.CloudAccountCredentialsService.ListCloudCredentials
 */
export const listCloudCredentials = CloudAccountCredentialsService.method.listCloudCredentials;

/**
 * @generated from rpc chalk.server.v1.CloudAccountCredentialsService.GetCloudCredentials
 */
export const getCloudCredentials = CloudAccountCredentialsService.method.getCloudCredentials;

/**
 * @generated from rpc chalk.server.v1.CloudAccountCredentialsService.CreateCloudCredentials
 */
export const createCloudCredentials = CloudAccountCredentialsService.method.createCloudCredentials;

/**
 * @generated from rpc chalk.server.v1.CloudAccountCredentialsService.UpdateCloudCredentials
 */
export const updateCloudCredentials = CloudAccountCredentialsService.method.updateCloudCredentials;

/**
 * @generated from rpc chalk.server.v1.CloudAccountCredentialsService.DeleteCloudCredentials
 */
export const deleteCloudCredentials = CloudAccountCredentialsService.method.deleteCloudCredentials;

/**
 * @generated from rpc chalk.server.v1.CloudAccountCredentialsService.TestCloudCredentials
 */
export const testCloudCredentials = CloudAccountCredentialsService.method.testCloudCredentials;

/**
 * @generated from rpc chalk.server.v1.CloudAccountCredentialsService.SimulateClusterPermissions
 */
export const simulateClusterPermissions = CloudAccountCredentialsService.method.simulateClusterPermissions;

/**
 * @generated from rpc chalk.server.v1.CloudAccountCredentialsService.SimulateVPCPermissions
 */
export const simulateVPCPermissions = CloudAccountCredentialsService.method.simulateVPCPermissions;
